// @ts-nocheck
// GENERATED from PropelMapper/design@b27d324 — do not edit.
import * as React from "react";
// PMCheckbox.tsx — PropelMapper checkbox.
// Square check with a label; Pine when on; --pm-focus-ring on keyboard focus.
// Uses a real (visually-hidden) <input type="checkbox"> for accessibility.

const PMCHK_CSS = `
.pmchk{box-sizing:border-box;display:inline-flex;align-items:flex-start;gap:10px;cursor:pointer;font:var(--pm-body-m);font-weight:600;color:var(--pm-fg-1);font-family:var(--pm-font-sans)}
.pmchk input{position:absolute;opacity:0;width:1px;height:1px;margin:0}
.pmchk-box{width:22px;height:22px;border-radius:6px;border:1.5px solid var(--pm-border-dark);display:grid;place-items:center;flex:0 0 22px;transition:.12s;background:var(--pm-surface);margin-top:1px}
.pmchk-box svg{width:14px;height:14px;opacity:0;transition:.12s;color:#fff;display:block}
.pmchk.is-on .pmchk-box{background:var(--pm-primary);border-color:var(--pm-primary)}
.pmchk.is-on .pmchk-box svg{opacity:1}
.pmchk input:focus-visible + .pmchk-box{box-shadow:var(--pm-focus-ring)}
.pmchk.is-disabled{opacity:.5;cursor:default}
.pmchk-tx{padding-top:1px}
`;
function pmchkEnsureCSS() {
  if (typeof document === "undefined" || document.getElementById("pmchk-css")) return;
  const s = document.createElement("style"); s.id = "pmchk-css"; s.textContent = PMCHK_CSS;
  document.head.appendChild(s);
}
export function PMCheckbox({ checked = false, onChange, disabled = false, label, className = "", style = {}, children, ...rest }) {
  pmchkEnsureCSS();
  return (
    <label className={"pmchk" + (checked ? " is-on" : "") + (disabled ? " is-disabled" : "") + (className ? " " + className : "")} style={style}>
      <input type="checkbox" checked={checked} disabled={disabled}
        onChange={(e) => onChange && onChange(e.target.checked)} {...rest} />
      <span className="pmchk-box">
        <svg viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M3.5 8.5l3 3 6-6.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>
      </span>
      {(label != null || children != null) ? <span className="pmchk-tx">{label != null ? label : children}</span> : null}
    </label>
  );
}
